import { render, staticRenderFns } from "./Wallets.vue?vue&type=template&id=d66370ce"
import script from "./Wallets.vue?vue&type=script&lang=js"
export * from "./Wallets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports